import * as types from "./types";

export const fetchingSessionId = () => ({
  type: types.FETCHING_SESSION_ID,
  loading: true
});

export const fetchedSessionId = () => ({
  type: types.FETCHED_SESSION_ID,
  loading: false
});

export const errorFetchingSessionId = (error) => ({
  type: types.ERROR_FETCHING_SESSION_ID,
  error: error,
  loading: false
});

export const fetchingPrypoolProducts = () => ({
  type: types.FETCHING_PRYPOOL_PRODUCTS,
  loading: true
});

export const fetchingSharingBox = () => ({
  type: types.FETCHING_SHARING_BOX,
  loading: true
});


export const fetchedSharingBox = (sharingBox) => ({
  type: types.FETCHED_SHARING_BOX,
  sharingBox: sharingBox,
  loading: false
});

export const fetchedPrypoolProducts = (products) => ({
  type: types.FETCHED_PRYPOOL_PRODUCTS,
  products: products,
  loading: false
});

export const errorFetchingSharingBox = (error) => ({
  type: types.ERROR_FETCHING_SHARING_BOX,
  error: error,
  loading: false
});

export const errorFetchingPrypoolProducts = (error) => ({
  type: types.ERROR_FETCHING_PRYPOOL_PRODUCTS,
  error: error,
  loading: false
});

export const pushProduct = (product) => ({
  type: types.PUSH_PRYPOOL_SELECTED_PRODUCT,
  product: product
});

export const removeProduct = (product) => ({
  type: types.REMOVE_PRYPOOL_SELECTED_PRODUCT,
  product: product
});
